import { ArtistTourType, mapArtistType, useFindArtistSuspense } from '@api';
import {
  LegacyAnchor,
  TouringCard,
  TouringCardActions,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
  TouringDataTable,
} from '@common';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/artists/$id.shows';
import { useArtistShowsColumns } from './hooks';

export const ArtistShows: React.FC = () => {
  const { t } = useTranslation('artistDetailsShows');
  const { id } = Route.useParams();
  const { data: tours } = useFindArtistSuspense(id, {
    query: { select: (data) => mapArtistType(data.data).tours },
  });
  const { columns } = useArtistShowsColumns();

  return (
    <TouringCard data-testid="artist-shows-container">
      <TouringCardHeader>
        <TouringCardTitle>{t('ARTIST_SHOWS.TITLE')}</TouringCardTitle>
        <TouringCardActions>
          <LegacyAnchor href={`/projects/touring#addTour-${id}`}>
            <Button color="blue" size="xs">
              <FontAwesomeIcon icon={faPlus} />
            </Button>
          </LegacyAnchor>
        </TouringCardActions>
      </TouringCardHeader>
      <TouringCardSection>
        <TouringDataTable<ArtistTourType>
          records={tours}
          columns={columns}
          withTableBorder={false}
          withColumnBorders={false}
          noHeader
          highlightOnHover={false}
        />
      </TouringCardSection>
    </TouringCard>
  );
};
